export const AuthConfig = {
  auth: {
    clientId: process.env['REACT_APP_CLIENT_ID'] as string,
    authority: "https://login.microsoftonline.com/ed5d5f47-52dd-48af-90ca-f7bd83624eb9", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: window.location.origin, // Set redirect to origin so it works for all routes
    navigateToLoginRequestUrl: true, // Return to the original URL after login
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set to true to handle browser redirects better
  }
};
const resource = process.env['REACT_APP_API_SCOPE']?.replace('api://', '').replace('/.default', '')
export const Consent = {
  url: `https://login.microsoftonline.com/ed5d5f47-52dd-48af-90ca-f7bd83624eb9/oauth2/authorize?client_id=${process.env['REACT_APP_CLIENT_ID']}&r&redirect_uri=${process.env['REACT_APP_REDIRECT_URI']}&response_mode=query&resource=${resource}&state=12345&response_type=id_token&prompt=consent`
}
// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [process.env['REACT_APP_API_SCOPE'] as string]
};